import React, { useState } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { commonStrings } from '../../../../../../core';
import { AdsStrings } from '../../../../business/core';
import { IAdsPlanCard } from '../../../interfaces';

export const AdsPlanCard: React.FC<IAdsPlanCard> = ({ plan, signedPlan, handlerShowModalPayment }) => {
    const navigate = useNavigate();
    const strings = AdsStrings['PTBR'].page;
    const currency_symbol = commonStrings()['PTBR'].core.currency_symbol;
    const [selectedOptions, setSelectedOptions] = useState([]);

    const handleSelectChange = (planId) => {
        setSelectedOptions(planId);
    };

    const handleSubmit = () => {
        if (!handlerShowModalPayment) {
            navigate("/ads/payment", {
                state: { id: plan.id, frequency: selectedOptions[plan.id] },
            });
        } else {
            handlerShowModalPayment({ id: plan.id, frequency: selectedOptions[plan.id] });
        }
    }

    return (
        <Col xs={12} sm={12} md={6} lg={4} xl={3}>
            <Card className={"py-3 mb-5"} style={{ height: 480 }}>
                <Card.Body>
                    <Card.Title className={"text-center text-uppercase"}>{`${strings.plans[plan.name].title}`}</Card.Title>
                    <Card.Subtitle
                        className={"text-center mb-3"}>
                        <p>
                            <small className={"text-uppercase"}
                                style={{ color: "white" }}>-</small>
                        </p>
                    </Card.Subtitle>
                    <Card.Text className={"text-center"}>
                        <Row>
                            <Col className={"p-0"}>
                                <small>{currency_symbol}</small><span style={{ fontSize: 50, fontWeight: "bold" }}>{plan.cost}</span>
                            </Col>
                        </Row>
                        {strings.plans[plan.name].description}
                    </Card.Text>
                    <div className="d-grid gap-2">
                        <Button
                            variant={"dark"}
                            onClick={() => handleSubmit()}
                            style={{ letterSpacing: -0.5 }}
                        >{strings.subscribe_button.label}</Button>
                    </div>
                </Card.Body>
            </Card>
        </Col>
    );
};